// Return a base URL for accessing the server endpoints
export const renderServerBase = () => {
	// Get the hostname of the current request
	const currentHost = window.location.hostname

	// Production domains for both apps, used to set the base url for server
	const ORBR_Domains = ["trackside-hospitality.redbull.racing", "www.trackside-hospitality.redbull.racing"]
	// Check the environment we're currently running in
	if (ORBR_Domains.includes(currentHost)) {
		// Production host
		return "https://trackside-hospitality.redbull.racing/api"
	} else if (currentHost === "localhost" || currentHost === "") {
		// Local host server - use the staging host
		return "https://trackside-hospitality-stage.herokuapp.com/api"
		// return "https://trackside-hospitality.redbull.racing/api"
	} else {
		// Anything else, process on the staging host
		return "https://trackside-hospitality-stage.herokuapp.com/api"
	}
}
